import { memory, session, local } from 'wix-storage';
import wixWindow from 'wix-window';
import { to, url } from 'wix-location';
import { fetch } from 'wix-fetch';
import { currentUser, applySessionToken } from 'wix-users';
import { createWixSession } from 'backend/vdgsa-auth.jsw';
import { getVdgsaSession } from 'public/vdgsa.js';


$w.onReady(function () {
    $w('#txtMessage').text = ""
    getVdgsaSession().then((vdgsaUser) => {
        $w('#txtMessage').show()
        console.log('vdgsaUser.username', vdgsaUser.username)
        console.log('vdgsaUser.subscription', vdgsaUser.subscription)
        if (vdgsaUser.username && vdgsaUser.subscription) {
            createWixSession(vdgsaUser.username)
                .then((sessionToken) => {
                    applySessionToken(sessionToken.sessionToken)
                        .then(() => {
                            console.log("User logged in.");
                        });
                    session.setItem('vdgsaUser', JSON.stringify(vdgsaUser))


                $w('#RenewButton').hide()
                $w('#LoginButton').show()
                }), (error) => {
                    console.log("error", error);
                };
        } else {
            if (!vdgsaUser.username) {
                $w('#txtMessage').text = vdgsaUser.detail
                $w('#RenewButton').hide()
                $w('#LoginButton').show()
            } else if (!vdgsaUser.subscription) {
                $w('#txtMessage').text = 'Your Subscription is not current.'
                $w('#RenewButton').show()
                $w('#LoginButton').hide()
            } 

        }
    })
});



export function goToLoginButton_click_1(event) {
    console.log('goToLoginButton_click', url)
    let currentPage = url;
    to(`https://hume.vdgsa.org/login/?next=${url}`)
}

export function goToRenewButton_click_1(event) {
    console.log('goToRenewButton_click', url)
    let currentPage = url;
    to(`https://hume.vdgsa.org/accounts/profile/?next=${url}`)
}

export function goToJoinButton_click_1(event) {
    console.log('goToJoinButton_click', url)
    let currentPage = url;
    to('https://hume.vdgsa.org/accounts/register/')
}